import {styled} from '@mui/material';
import {DataGridPro} from '@mui/x-data-grid-pro';

export const StickyDataGrid = styled(DataGridPro)(({theme}) => ({
  '& .MuiDataGrid-columnHeaders': {
    position: 'sticky',
    // Replace background colour if necessary
    backgroundColor: theme.palette.background.paper,
    // Display header above grid data, but below any popups
    zIndex: theme.zIndex.mobileStepper - 1,
  },
  '& .MuiDataGrid-virtualScroller': {
    // Undo the margins that were added to push the rows below the previously fixed header
    marginTop: '0 !important',
  },
  '& .MuiDataGrid-main': {
    // Not sure why it is hidden by default, but it prevented the header from sticking
    overflow: 'visible',
  },
  // '& .MuiDataGrid-virtualScrollerContent': {
  //   height: '500px !important',
  // },
  border: 0,
  borderRadius: 0,
}));
